module.exports = __webpack_public_path__ + "img/topHeader.8fc1a504.png";